import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';

import StatusBar from '../../containers/status-bar';
import { setStatusBar } from '../../containers/status-bar/actions';
import CampaignCreate from './campaign-create';
import CampaignInvite from './campaign-invite';
import Invitation from '../../containers/invitation';

const Scroll = require('react-scroll');

const scroll = Scroll.animateScroll;


class CampaignNew extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor() {
    super();

    this.state = {
      campaignCreated: false,
      campaignId: null,
    };
  }

  setCampaignCreated(bool) {
    this.setState({ campaignCreated: bool });
    if (bool) scroll.scrollToTop();
  }

  setCampaignData(campaignId, campaignName) {
    this.setState({ campaignId, campaignName });
  }

  getProfile() {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem('profile');
    return profile ? JSON.parse(localStorage.profile) : {};
  }

  render() {
    const { campaignCreated, campaignId, campaignName } = this.state;
    const profile = this.getProfile();
    const organisationId = profile.app_metadata.dyzio.o_id;

    return (
      <div className="page">

        <div className="page-content">
          <div className="grid">

            <StatusBar />

            { !campaignCreated
              ? <CampaignCreate
                setCampaignCreated={bool => this.setCampaignCreated(bool)}
                setCampaignData={(campaignId, campaignName) => this.setCampaignData(campaignId, campaignName)}
              />
              : <Invitation campaignId={campaignId} campaignName={campaignName} organisationId={organisationId} />
            }
          </div>
        </div>
      </div>
    );
  }
}

CampaignNew.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  currentUser: state.userData.get('currentUser'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetStatusBar: (message, colour) =>
      dispatch(setStatusBar(message, colour)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignNew);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-new/index.js
 **/